import React from "react";
import RegionConfigurationSearchMap from "../../../../components/Map/RegionConfigurationSearchMap";
import VehicleList from "../VehicleList";

class VehicleSearch extends React.Component {

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-xl col-lg">
            <div className="card shadow mb-4">
              <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                <h6 className="m-0 font-weight-bold" style={{color: '#333399'}}>Vehicle Search Map</h6>
              </div>

              <div className="card-body">
                <RegionConfigurationSearchMap/>
                <br/>
                <VehicleList/>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default VehicleSearch;